import { render, staticRenderFns } from "./PeakDetails.vue?vue&type=template&id=235b0978&scoped=true&"
import script from "./PeakDetails.vue?vue&type=script&lang=js&"
export * from "./PeakDetails.vue?vue&type=script&lang=js&"
import style0 from "./PeakDetails.vue?vue&type=style&index=0&id=235b0978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b0978",
  null
  
)

export default component.exports